<!-- <breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb> -->
<div *ngIf="accessLoader || detailsLoader!==null" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<div class="card" *ngIf="apptModuleAccess=='Full'">
	<h2 class="card-title mb-0 pb-0">
		Training
		<a class="btn btn-sm btn-outline-success float-end" [routerLink]="['/app/create-appointment']">
			<fa-icon [icon]="['fas', 'plus']"></fa-icon>
			Create Training
		</a>
	</h2>
	<div class="card-body pt-1">
		<div class="row">
			<div class="col-md-12">
				<mat-accordion [hideToggle]="false">
					<mat-expansion-panel>
						<mat-expansion-panel-header class="bg-theme" [collapsedHeight]="'35px'"
							[expandedHeight]="'40px'">
							<mat-panel-title>
								<b class="text-light">Advanced Options</b>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div class="row g-1 mt-2">
							<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
								<!-- <ng-select appendTo="body" [items]="companyList" bindLabel="comp_name"
									bindValue="apptid" [clearable]="true" [multiple]="false" id="company"
									[(ngModel)]="filters.company" placeholder="Company"
									(change)="getVesselListByCompany(true);getBranchListByCompany(true);refreshTable();"
									[appearance]="'outline'">
								</ng-select> -->
								<ng-select appendTo="body" [items]="companyList" bindLabel="comp_name"
									bindValue="apptid" [clearable]="true" [multiple]="false" id="company"
									[(ngModel)]="filters.company" placeholder="Company" (change)="refreshTable();"
									[appearance]="'outline'">
								</ng-select>
							</div>
							<!-- <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
								<ng-select appendTo="body" [items]="branchList" bindLabel="name" bindValue="id"
									[clearable]="true" [multiple]="false" id="branch" [(ngModel)]="filters.branch"
									placeholder="Branch" (change)="refreshTable();" [appearance]="'outline'">
								</ng-select>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
								<ng-select appendTo="body" [items]="vesselList" bindLabel="vessel" bindValue="id"
									[clearable]="true" [multiple]="false" id="vessel" [(ngModel)]="filters.vessel"
									placeholder="Vessel" (change)="refreshTable();" [appearance]="'outline'">
								</ng-select>
							</div> -->
							<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
								<mat-form-field appearance="outline">
									<mat-label>From</mat-label>
									<input matInput [matDatepicker]="from_picker_template"
										[(ngModel)]="filters.fromDate" (change)="refreshTable()">
									<mat-hint>MM/DD/YYYY</mat-hint>
									<mat-datepicker-toggle matIconSuffix
										[for]="from_picker_template"></mat-datepicker-toggle>
									<mat-datepicker #from_picker_template (closed)="refreshTable()"></mat-datepicker>
								</mat-form-field>
							</div>
							<div class="col-lg-2 col-md-2 col-sm-12 col-xs-12">
								<mat-form-field appearance="outline">
									<mat-label>To</mat-label>
									<input matInput [matDatepicker]="to_picker_template" [(ngModel)]="filters.toDate"
										(change)="refreshTable()">
									<mat-hint>MM/DD/YYYY</mat-hint>
									<mat-datepicker-toggle matIconSuffix
										[for]="to_picker_template"></mat-datepicker-toggle>
									<mat-datepicker #to_picker_template (closed)="refreshTable()"></mat-datepicker>
								</mat-form-field>
							</div>
							<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
								<!-- <button type="button" (click)="downloadExcel()"
									class="btn btn-xs btn-outline-primary float-end mt-2" matTooltip="Download Excel">
									<fa-icon *ngIf="!excelLoader" [icon]="['fas', 'cloud-download-alt']"></fa-icon>
									<fa-icon *ngIf="excelLoader" [icon]="['fas', 'spinner']"
										[animation]="'spin'"></fa-icon>
								</button> -->
							</div>
						</div>
					</mat-expansion-panel>
				</mat-accordion>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="table-responsive">
					<table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered table-hover"
						style="width: 100%;">
						<thead>
							<tr class="table_head">
								<th style="width: 25% !important;">Company</th>
								<th style="width: 20% !important;">Profile</th>
								<th style="width: 10% !important;">DOE</th>
								<th style="width: 15% !important;">Ref. No.</th>
								<th style="width: 10% !important;">Participants</th>
								<th style="width: 10% !important;">No. of Trainers</th>
								<!-- <th style="width: 10% !important;">Training Done</th> -->
								<th style="width: 10% !important;">Action</th>
							</tr>
						</thead>
						<tbody *ngIf="dataList?.length != 0">
							<tr *ngFor="let v of dataList;let i = index;">
								<td>
									<span role="button" (click)="getApptDetails(i)" matTooltip="Click for details">
										{{ v.company_name }}
									</span>
								</td>
								<td>
									<span role="button" (click)="getApptDetails(i)" matTooltip="Click for details">
										{{ v.profile_name }}
									</span>
								</td>
								<td>
									<span role="button" (click)="getApptDetails(i)" matTooltip="Click for details">
										{{ v["DOE"] }}
									</span>
								</td>
								<td>
									<span role="button" (click)="getApptDetails(i)" matTooltip="Click for details">
										{{ v.ref_no }}
									</span>
								</td>
								<td>
									<span role="button" (click)="getApptDetails(i)" matTooltip="Click for details">
										<!-- {{ v.numberOfCandidate || v.appt_list.length }} -->
										{{ v.numberOfCandidate }}
									</span>
								</td>
								<td>
									<span role="button" (click)="getApptDetails(i)" matTooltip="Click for details">
										{{ v.numberOfTrainers }}
									</span>
								</td>
								<!-- <td>
									<ng-toggle [(ngModel)]="v.status"
										[color]="{ unchecked: '#bfcbd9', checked: '#2494f2' }"
										[fontColor]="{checked: '#ffffff',unchecked: '#000000'}"
										[switchColor]="{checked: '#4caf50',unchecked: '#f23022'}"
										[labels]="{'unchecked': 'Not Done','checked': 'Done'}" [width]="100"
										(change)="changeTrainingDone(v,i)"></ng-toggle>
									<fa-icon *ngIf="showIsDoneLoader == i" [icon]="['fas', 'spinner']"
										[animation]="'spin'" class="ms-1"></fa-icon>
								</td> -->
								<td>
									<a class="btn btn-xs btn-outline-info" matTooltip="Report"
										[routerLink]="['/app/report',v.ref_no]">
										<fa-icon [icon]="['fas', 'file']"></fa-icon>
									</a>
									<a class="btn btn-xs btn-outline-primary ms-1" matTooltip="Edit"
										id="btnEdit{{v.ref_no}}" [routerLink]="['/app/edit-appointment',v.ref_no]">
										<fa-icon [icon]="['fas', 'edit']"></fa-icon>
									</a>
									<!-- <button type="button" (click)="createTrainingCertificate(i)"
										class="btn btn-xs btn-outline-info ms-1" matTooltip="Certificates">
										<fa-icon *ngIf="pdfDownloadLoader1 != i"
											[icon]="['fas', 'cloud-download-alt']"></fa-icon>
										<fa-icon *ngIf="pdfDownloadLoader1 == i" [icon]="['fas', 'spinner']"
											[animation]="'spin'"></fa-icon>
									</button> -->
									<button type="button" (click)="deleteConfirm(v.ref_no,i)"
										class="btn btn-xs btn-outline-danger ms-1" matTooltip="Delete">
										<fa-icon *ngIf="deleteLoader != i" [icon]="['fas', 'times']"></fa-icon>
										<fa-icon *ngIf="deleteLoader == i" [icon]="['fas', 'spinner']"
											[animation]="'spin'"></fa-icon>
									</button>
								</td>
							</tr>
						</tbody>
						<tbody *ngIf="dataList?.length == 0">
							<tr>
								<td colspan="7" class="text-center">No data found!</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
<div *ngIf="apptModuleAccess!='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
<div class="modal fade" id="apptDetailsModal" role="dialog">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title"><strong>Training Details</strong></h4>
				<button type="button" class="btn-close" (click)="clearApptDetailsModal();"></button>
			</div>
			<div class="modal-body" *ngIf="participants.length">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<div class="table-responsive">
							<table class="table table-bordered">
								<tbody>
									<tr>
										<th style="width: 15%;">Company</th>
										<td style="width: 35%;">{{participants[0].company_name}}</td>
										<th style="width: 15%;">Profile</th>
										<td style="width: 35%;">{{participants[0].profile_name}}</td>
									</tr>
									<tr>
										<th>Ref. No.</th>
										<td>{{participants[0]['ref_no']}}</td>
										<th>DOE</th>
										<td>{{participants[0]['DOE']}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<h4 class="text-center">
							{{getParticipantText()}}
						</h4>
						<div class="table-responsive">
							<table class="table table-bordered">
								<thead>
									<tr>
										<th style="width: 5%;">
											<mat-checkbox color="primary" [(ngModel)]="selectAll"
												(change)="check_uncheck_all()">
											</mat-checkbox>
										</th>
										<th style="width: 35%;">Participant</th>
										<th style="width: 25%;">Rank</th>
										<th style="width: 35%;">Trainer</th>
										<!-- <th style="width: 5%;">Report</th> -->
									</tr>
								</thead>
								<tbody>
									@if(participants.length==1 && participants[0].name==null){
									<tr>
										<td colspan="4">
											<h4 class="text-center">
												No Details of participants
											</h4>
										</td>
									</tr>
									}@else{
									<tr *ngFor="let cand of participants;let i = index;">
										<td>
											<mat-checkbox color="primary" [(ngModel)]="cand.selected"
												(change)="check_uncheck_single()">
											</mat-checkbox>
										</td>
										<td>
											<app-gender-icon [gender]="cand.gender"></app-gender-icon>
											{{cand.name}}
										</td>
										<td>{{cand.rank_name}}</td>
										<td>{{cand.trainer}}</td>
										<!-- <td>
											<a class="btn btn-xs btn-info" matTooltip="Report" data-bs-dismiss="modal"
												[routerLink]="['/app/userscore',cand.encrypt_id]">
												<fa-icon [icon]="['fas', 'file']">
												</fa-icon>
											</a>
										</td> -->
									</tr>
									}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-outline-info" (click)="gotoQueAns();">
					Answers
				</button>
				<button type="button" class="btn btn-outline-dark" (click)="clearApptDetailsModal();">
					Close
				</button>
			</div>
		</div>
	</div>
</div>